module.exports = __webpack_public_path__ + "static/media/Даллул Мариана  (КФА).1200c77b.pdf";